const { AddCircle } = require("@mui/icons-material");
const { Button } = require("@mui/material")
const { useTranslation } = require("react-i18next")

const IndieNewItemButton = ({label, ...params}) => {
    const { t } = useTranslation();
    return <Button startIcon={<AddCircle/>} variant="outlined" {...params}>{label ? label : t("label.button.new")}</Button>
}

export default IndieNewItemButton;